import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import React, { useRef, useState } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import Copyright from '../../../app/Copyright';
import { useAuth } from '../../../contexts/AuthContext';
import { Alert } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function EmailSignUp() {
    const classes = useStyles();
    const auth = useAuth();
    const firstnameRef = useRef<TextFieldProps>(null);
    const lastnameRef = useRef<TextFieldProps>(null);
    const emailRef = useRef<TextFieldProps>(null);
    const passwordRef = useRef<TextFieldProps>(null);
    const [error, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [taAccepted, setTaAccepted] = useState(false);
    const history = useHistory();

    const handleSignUp = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        try {
            const firstName = firstnameRef.current?.value as string;
            const lastName = lastnameRef.current?.value as string;
            const email = emailRef.current?.value as string;
            const password = passwordRef.current?.value as string;
            if (email.trim() && password.trim() && firstName.trim() && lastName.trim()) {
                const result = await auth?.signup(email, password);
                if (result) {
                    await result.user?.updateProfile({
                        displayName: firstName + " " + lastName
                    });
                }
                setLoading(false);
                history.push('/signin');
            }
        } catch (e) {
            setErrorMessage("Signup failed");
            console.error(e);
            setLoading(false);
        }
    }
    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                {
                    error && <Alert severity="error">{error}</Alert>
                }
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign up
        </Typography>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                autoComplete="fname"
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                id="firstName"
                                label="First Name"
                                autoFocus
                                inputRef={firstnameRef}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="lastName"
                                label="Last Name"
                                name="lastName"
                                autoComplete="lname"
                                inputRef={lastnameRef}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                inputRef={emailRef}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                inputRef={passwordRef}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Checkbox value="allowExtraEmails" color="primary" onChange={(e) => setTaAccepted(e.target.checked)} />}
                                label={
                                    <div>
                                        <Typography>I acknowledge that I have read and agree to the <Link href="#">terms and conditions</Link></Typography>
                                    </div>
                                }
                            />
                        </Grid>

                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={handleSignUp}
                        disabled={!taAccepted || loading}
                    >
                        Sign Up
          </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link href="/signin" variant="body2">
                                Already have an account? Sign in
              </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>
                <Copyright />
            </Box>
        </Container>
    );
}